import { initiateGam } from '@client/adManager/initiateGam.js';
import { $config } from '@client/core/atoms/config.js';
import { getInterminglePlacements } from '@client/core/atoms/placements.js';
import { setupTravelEvents } from '@client/core/utils/events/setupTravelEvents.js';
import { events, messageBus } from '@schibsted-nmp/advertising-events';
import {
  debugLog,
  PageType,
  Vertical
} from '@schibsted-nmp/advertising-shared';

import {
  checkMiddleBannerCollisions,
  initializeFilterCollisionDetection,
  disconnectFilterObserver
} from '../dom/handleAdsOverlap/filterCollisionDetection.js';
import { refreshKeywords } from '../refreshKeywords.js';

let cleanupHandler: (() => void) | null = null;

export function setupEvents() {
  const { pageType, vertical } = $config.get() ?? {};

  if (cleanupHandler) {
    window.removeEventListener('beforeunload', cleanupHandler);
    cleanupHandler = null;
  }

  // Keep this for backward compatibility
  const interminglePlacements = getInterminglePlacements();

  debugLog('placementsWithIntermingle: ', interminglePlacements);

  if (interminglePlacements.length > 0) {
    messageBus.publish('advertising-podlet', 'podlet-ready', {
      placementsWithIntermingle: interminglePlacements
    });
  }

  if (vertical === Vertical.Travel) {
    setupTravelEvents();
  } else if (pageType === PageType.Result) {
    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.FILTER.topic,
      refreshKeywords.sync
    );

    messageBus.subscribe(
      events.SEARCH.channel,
      events.SEARCH.EXPANDABLE_UPDATE.topic,
      () => {
        checkMiddleBannerCollisions();
      }
    );

    initializeFilterCollisionDetection();

    cleanupHandler = () => {
      disconnectFilterObserver();
    };

    window.addEventListener('beforeunload', cleanupHandler);
  }

  if (pageType === PageType.Object) {
    messageBus.subscribe(
      events.ITEM_PAGE.channel,
      events.ITEM_PAGE.INCAROUSEL_IMAGE_UPDATE.topic,
      initiateGam.handleInCarouselImageUpdate
    );
  }
}
